import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {Redirect, Switch} from 'react-router-dom'
import * as auth from './redux/AuthRedux'
import { DEFAULT_ROUTE } from '../../routing/routes.config'

export function Logout() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(auth.actions.logout())
    setTimeout(() => {
      document.location.href = DEFAULT_ROUTE
    }, 100)
    // document.location.reload() // <- fix the delay or show the loading screen
  }, [dispatch])

  return (
    <Switch>
      <Redirect to={DEFAULT_ROUTE} />
    </Switch>
  )
}
